import React, {useEffect, useState} from 'react'
import api from "../../api";
import {Button, Col, Row, Table, Tabs, Select} from "antd";
import {useNavigate} from "react-router-dom";
import OrderStatusLabel from "../../Components/OrderStatusLabel";
import dayjs from "dayjs";
import {printPrice} from "../../helpers";

const { Option } = Select;

export default function Orders() {

    const [orders, setOrders] = useState([]);
    const [stats, setStats] = useState(null);
    const [salesOverview, setSalesOverview] = useState([]);
    const [dateRange, setDateRange] = useState('all_time');
    const navigate = useNavigate()

    useEffect(() => {
        api.getCompanyOrders().then((setOrders))
        api.getOrderStats().then((setStats))
    }, []);

    useEffect(() => {
        api.getSalesOverview(dateRange).then((setSalesOverview))
    }, [dateRange]);

    const tableOrders = orders.map((order) => {
        return {
            ...order,
            mobile_id: `${order.id}-mobile`
        }
    })

    const tabItems = [
        {
            key: 'orders',
            label: 'Orders',
            children: (
                <>
                    <Row style={{ marginBottom: 16, marginTop: 24 }}>
                        <Col span={24}>
                            <Button
                                type="primary"
                                onClick={() => navigate('/orders/create')}
                            >
                                Handmatige Bestelling Aanmaken
                            </Button>
                        </Col>
                    </Row>

                    <h1>Orders</h1>
                    <Table dataSource={tableOrders} columns={[
                        {
                            title: 'Bestelling', key: 'mobile_id', responsive: ['xs'], render(order) {
                                return (
                                    <Row onClick={() => {
                                        navigate(`/order/status/${order.id}/${order.secret}`)
                                    }}>
                                        <Col span={20}>#{order.id} - {order.name}</Col>
                                        <Col span={4}><OrderStatusLabel status={order.status}/></Col>
                                        <Col span={12}>
                                            {order.created_at &&
                                                <span>{dayjs(order.created_at).fromNow()}</span>
                                            }
                                        </Col>
                                    </Row>
                                )

                            }
                        },
                        {title: 'Order nummer', dataIndex: 'id', key: 'id', responsive: ['md']},
                        {title: 'Datum', dataIndex: 'created_at', key: 'created_at', responsive: ['md']},
                        {
                            title: 'Status', dataIndex: 'status', key: 'status', responsive: ['md'], render(status) {
                                return <OrderStatusLabel status={status}/>
                            }
                        },
                        {title: 'Koper', dataIndex: 'name', key: 'name', responsive: ['md']},
                        {
                            title: 'Acties', key: 'actions', responsive: ['md'], render: (text, record) => (
                                <>
                                    <Button onClick={() => {
                                        navigate(`/order/status/${record.id}/${record.secret}`)
                                    }}>Bekijken</Button>
                                </>
                            )
                        }
                    ]}>

                    </Table>
                </>
            )
        },
        {
            key: 'sales-overview',
            label: 'Verkoop overzicht',
            children: (
                <>
                    <h1>Verkoop overzicht</h1>
                    <Row style={{ marginBottom: 16, marginTop: 24 }}>
                        <Col span={24}>
                            <label style={{ marginRight: 8 }}>Periode:</label>
                            <Select
                                value={dateRange}
                                onChange={setDateRange}
                                style={{ width: 200 }}
                            >
                                <Option value="all_time">Alle tijd</Option>
                                <Option value="last_365_days">Laatste 365 dagen</Option>
                                <Option value="last_30_days">Laatste 30 dagen</Option>
                                <Option value="last_7_days">Laatste 7 dagen</Option>
                                <Option value="this_year">Dit jaar</Option>
                                <Option value="last_year">Vorig jaar</Option>
                                <Option value="this_month">Deze maand</Option>
                                <Option value="last_month">Vorige maand</Option>
                            </Select>
                        </Col>
                    </Row>
                    <Table
                        dataSource={salesOverview}
                        rowKey={(record) => record.item_name}
                        pagination={false}
                        columns={[
                            {
                                title: 'Product',
                                dataIndex: 'item_name',
                                key: 'item_name',
                                sorter: (a, b) => a.item_name.localeCompare(b.item_name)
                            },
                            {
                                title: 'Aantal verkocht',
                                dataIndex: 'quantity_sold',
                                key: 'quantity_sold',
                                align: 'right',
                                sorter: (a, b) => a.quantity_sold - b.quantity_sold,
                                defaultSortOrder: 'descend'
                            },
                            {
                                title: 'Totale omzet',
                                dataIndex: 'total_revenue',
                                key: 'total_revenue',
                                align: 'right',
                                render: (revenue) => printPrice(revenue, false),
                                sorter: (a, b) => a.total_revenue - b.total_revenue
                            }
                        ]}
                    />
                </>
            )
        }
    ];

    return (
        <div>
            <h1>Statistieken</h1>
            {stats && (
                <Row>
                    <Col md={4} xs={12} sm={12} className={"text-center"}>
                        <h2>Aantal bestellingen</h2>
                        <h3>{stats.total_orders}</h3>
                    </Col>
                    <Col md={4} xs={12} sm={12} className={"text-center"}>
                        <h2>Totaal omzet</h2>
                        <h3>{printPrice(stats.total_revenue, false)}</h3>
                    </Col>
                    <Col md={4} xs={12} sm={12} className={"text-center"}>
                        <h2>Te leveren</h2>
                        <h3>{stats.paid_orders}</h3>
                    </Col>
                    <Col md={4} xs={12} sm={12} className={"text-center"}>
                        <h2>Afgehandeld</h2>
                        <h3>{stats.handled_orders}</h3>
                    </Col>
                    <Col md={4} xs={12} sm={12} className={"text-center"}>
                        <h2>Uitbetaald</h2>
                        <h3>{stats.completed_orders}</h3>
                    </Col>
                    <Col md={4} xs={12} sm={12} className={"text-center"}>
                        <h2>Totaal uitbetaald</h2>
                        <h3>{printPrice(stats.completed_total, false)}</h3>
                    </Col>
                </Row>
            )}

            <Tabs defaultActiveKey="orders" items={tabItems} style={{ marginTop: 24 }} />
        </div>
    )
}